import { lazy } from "react"
import { RouteProps } from "../features.types"

const TermsHome = lazy(() => import("./terms"))
const TermsController = lazy(() => import("./controller"))

// define route constant
export const TERMS_ROUTE = "/user/terms"

//define routes
export const Terms: RouteProps[] = [
  {
    path: TERMS_ROUTE,
    Component: TermsController,
    children: [
      {
        index: true,
        Component: TermsHome,
      },
    ],
  },
]
